// extracted by mini-css-extract-plugin
export default {"emptyViewMessage":"EmptyViewMessage_emptyViewMessage__OPA9M","messageText":"EmptyViewMessage_messageText__KB0ir"};